import React from "react";
import { motion } from "framer-motion";
import { EASE } from "../../lib/motion";
import { NavLink } from "./NavLink";

/**
 * Mobile-only nav sheet. Renders nothing when closed so it stays
 * out of the DOM tab order.
 */
export const MobileMenu = ({ open, links, content, onNavigate, onLogin, onBook }) => {
    if (!open) return null;
    return (
        <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: EASE }}
            className="lg:hidden pointer-events-auto mx-auto max-w-[1240px] mt-2 p-6 glass-modal"
            data-testid="nav-mobile-sheet"
        >
            <div className="flex flex-col gap-4">
                {links.map((l) => (
                    <NavLink key={l.label} link={l} variant="mobile" onNavigate={onNavigate} />
                ))}
                <button
                    onClick={onLogin}
                    className="nav-link font-body text-lg text-left"
                    data-testid="nav-mobile-login"
                >
                    {content?.nav?.login_label || "Login"}
                </button>
                <button
                    type="button"
                    onClick={onBook}
                    className="btn-pill btn-pill-dark text-sm mt-2"
                    data-testid="nav-mobile-cta"
                >
                    {content?.nav?.cta_label || "Book Demo"}
                </button>
            </div>
        </motion.div>
    );
};
